"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_use_1 = require("react-use");
var hooks_1 = require("../../hooks");
var data_entry_1 = require("../data-entry");
var layout_1 = require("../layout");
var style_1 = require("../../style");
var styles = {
    common: react_1.css({
        fontSize: 14,
        lineHeight: '21px',
        fontWeight: 400,
        color: "var(" + style_1.RootColor.Gray.DEFAULT + ")",
    }),
    totalPages: react_1.css({
        color: "var(" + style_1.RootColor.Gray.DARK_4 + ")",
    }),
};
var QuickJumper = function (props) {
    var totalPages = props.totalPages, currentPage = props.currentPage, onChange = props.onChange;
    var _a = hooks_1.useDerivedState(function () { return "" + currentPage; }, [currentPage]), pendingPage = _a[0], setPendingPage = _a[1];
    var handleChangeEventCall = function (pageNumber, resetPendingPage) {
        if (resetPendingPage === void 0) { resetPendingPage = false; }
        var newPage = pageNumber;
        if (pageNumber < 1) {
            newPage = totalPages ? 1 : totalPages;
        }
        else if (pageNumber > totalPages) {
            newPage = totalPages;
        }
        resetPendingPage && setPendingPage("" + newPage);
        (newPage !== currentPage) && onChange(newPage);
    };
    react_use_1.useDebounce(function () {
        handleChangeEventCall(Number(pendingPage));
    }, 1000, [pendingPage]);
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 8 },
        react_1.jsx("div", { css: styles.common }, "Page"),
        react_1.jsx(data_entry_1.NumberInput, { size: props.size === 'sm' ? 'small' : 'large', inputProps: {
                min: totalPages ? 1 : 0,
                max: totalPages,
                onBlur: function (_a) {
                    var target = _a.target;
                    return handleChangeEventCall(Number(target.value), true);
                },
                onKeyDown: function (_a) {
                    var key = _a.key, currentTarget = _a.currentTarget;
                    (key === 'Enter') && handleChangeEventCall(Number(currentTarget.value), true);
                },
            }, "data-6si-name": "pagination--page-input", onChange: setPendingPage, error: Number(pendingPage) > totalPages ||
                Number(pendingPage) < (totalPages ? 1 : 0), value: pendingPage }),
        react_1.jsx("div", { css: styles.common },
            "of ",
            react_1.jsx("span", { css: styles.totalPages }, totalPages))));
};
exports.default = QuickJumper;
